<template>
  <div>
    <div
      id="add-font-sidebar-overlay"
      class="fou-add-font-sidebar-overlay"
      @click="closeSidebar"
    />
    <div
      id="add-font-sidebar-wrapper"
      ref="scrollElement"
      class="fou-add-font-sidebar-wrapper"
    >
      <div :class="['add-font-sidebar-container', {'is-showing-result' : !isFamiliesLoading && responseSearchTerm}]">
        <div class="add-font-sidebar-container__header">
          <div class="fou-add-fonts-title-wrap is-flex is-flex--justify-between is-flex--align-center">
            <h2
              data-qa-id="add-fonts-title"
              class="mt-e-title"
            >
              {{ $t('pages.bundle.draft.add_fonts') }}
            </h2>
            <div
              data-qa-id="close-button"
              class="fou-font-close-btn"
              @click="closeSidebar"
            >
              <Close class="close-icon" />
            </div>
          </div>
          <div class="fou-add-font-sidebar-searchwrap">
            <search-icon
              data-qa-id="search-icon"
              class-name="fou-add-font-search-icon"
              @click="searchFamilies()"
            />
            <input
              ref="searchInput"
              v-model="searchTerm"
              data-qa-id="search-input"
              type="text"
              :placeholder="$t('pages.bundle.draft.search_fonts')"
              class="fou-add-font-search"
              :disabled="isFamiliesLoading"
              @input="handleSearchInput"
              @keydown.enter.prevent="searchFamilies()"
            >
          </div>

          <div
            v-if="!isFamiliesLoading && responseSearchTerm"
            data-qa-id="search-result-header"
            class="fou-add-font-sidebar-searchwrap fou-add-sidebar--result-header"
          >
            <div class="fou-add-font-arrow-back">
              <ArrowBack @click="handleArrowBack()" />
            </div>
            <div class="fou-add-font-search is-flex is-flex--align-center">
              {{ pagination?.totalCount }} results for "{{ responseSearchTerm }}"
            </div>
          </div>
        </div>

        <div
          data-qa-id="font-families-wrapper"
          class="font-list"
        >
          <template v-if="!isFamiliesLoading && isEmpty(formattedFamilies) && !responseSearchTerm">
            <div class="text-center pt-1 font-list__na">
              {{ $t('pages.bundle.draft.no_families') }}
            </div>
          </template>
          <template v-else>
            <FamilyItem
              v-for="family in formattedFamilies"
              :key="family.familyId"
              :family="family"
              @accordion-click="familyId => getFamilyDetail(familyId)"
              @update:add-font="familyInfo => toggleAddFont(familyInfo)"
            />
          </template>
        </div>
        <div
          v-if="isFamiliesLoading"
          data-qa-id="loader"
          class="wrapper"
        >
          <AnimationProcessing
            fill="new-blue"
            class="pageSpinner"
            data-qa-id="loading-icon"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./index" />

<style lang="scss">
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/variables/fonts';
@import 'mpl-css/lib/assets/global/variables/grid';
@import 'mpl-css/lib/assets/global/variables/breakpoints';
@import 'mpl-css/lib/assets/global/variables/layout';
@import 'mpl-css/lib/assets/global/functions/index';
@import 'mpl-css/lib/assets/global/mixins/index';


.fou-add-font-sidebar-overlay {
  z-index: 9999;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: rgba($color: map-get($colors, 'black'), $alpha: 0.22);
}

.fou-add-font-sidebar-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 999999;
  overflow-y: auto;
  min-width: rem(520);
  max-width: rem(520);
  height: 100vh;
  background-color: map-get($colors, 'white');

  @media screen and (max-width: 719px) {
    min-width: 0;
    max-width: none;
    width: 100%;
  }

  .add-font-sidebar-container {

    .add-font-sidebar-container__header {
      position: sticky;
      top: 0;
      background: map-get($colors, 'white');
      z-index: 2;

      .fou-add-fonts-title-wrap {
        border-bottom: 1px solid map-get($colors, 'spirits--300');
        padding: rem(24);

        .mt-e-title {
          margin: 0;
          font-weight: bold;
          font-size: rem(23);
          line-height: rem(32);
          letter-spacing: rem(-0.23);
          color: map-get($colors, 'spirits--900');
        }

        .fou-font-close-btn {
          cursor: pointer;
          height: rem(20);
          width: rem(20);
        }
      }

      .fou-add-font-sidebar-searchwrap {
        position: relative;
        border-bottom: 1px solid map-get($colors, 'spirits--300');

        .fou-add-font-search-icon,
        .fou-add-font-arrow-back {
          position: absolute;
          left: rem(24);
          top: 50%;
          transform: translateY(-50%);
          line-height: 1;

          svg {
            vertical-align: bottom;
          }
        }

        .fou-add-font-arrow-back {
          margin-top: rem(-2);
        }

        .fou-add-font-search {
          font-family: $mt-regular;
          width: 100%;
          height: rem(56);
          padding: 0 rem(24) 0 rem(48);
          font-size: rem(13);
          line-height: rem(16);

          &::placeholder {
            font-size: rem(13);
            color: map-get($colors, 'spirits--600');
          }

          &:focus {
            border: none;
            outline: none;
          }
        }

        &.fou-add-sidebar--result-header {

          .fou-add-font-search {
            font-size: rem(16);
            line-height: rem(24);
            letter-spacing: rem(-0.23);
          }
        }
      }
    }

    .font-list {
      // margin-top: 138px;

      .fou-add-font-sidebar-block {
        margin: 0;

        .heading {

          .title {
            line-height: rem(24);

            .fou-add-font-sidebar-block-title {

              .fou-add-font-sidebar-monotype-icon {
                line-height: 1;
              }

              .fou-add-font-sidebar-family-title {
                margin-right: 0;
              }

              .fou-add-font-sidebar-family-seperator {
                margin: 0 8px;
              }

              .fou-add-font-sidebar-family-foundry {
                margin-left: 0;
              }
            }

            &::after {
              background: none;
              transform: translateY(-50%) rotate(-45deg);
              transform-origin: center;
              width: 10px;
              height: 10px;
              border-bottom: 2px solid map-get($colors, 'spirits--600');
              border-left: 2px solid map-get($colors, 'spirits--600');
              transition: all 400ms ease-in-out;
            }
          }

          .fou-add-family-imgage-wrap {
            overflow: hidden;

            .font-style-image {
              height: 56px;
              width: auto;
            }
          }
        }

        [open] .heading > .title:after {
          transform: translateY(-50%) rotate(135deg);
        }
      }
    }



    .wrapper {
      display: grid;
      align-self: center;
      margin-top: auto;
      justify-items: center;
    }
  }

  .fou-add-font-sidebar-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .pageSpinner {
    margin-bottom: 44px;
    width: 4.4rem;
    height: auto;
  }
}

.text-underline {
  text-decoration: underline;
}

.cursor-pointer {
  cursor: pointer;
}

.align-self-center {
  align-self: center;
}
.close-icon {
  margin-left: 8px;
}

.text-center {
  text-align: center;
}

.pt-1 {
  padding-top: 1rem;
}

.font-list__na {
  padding: 16px 24px;
}
</style>

